<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure>
                          <img :src="$iconFolder + 'voucher.svg'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Voucher <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="print()" class="bt-print" v-if="resource && resource.id"><span><i class="icon icon-printer"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                        <notice-published v-model="resource" label-published="Ce promo code est actif." label-unpublished="Ce promo code est inactif." :dates="true"></notice-published>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset style="position: relative;">
                                <h3>Détail du coupon</h3>
                                <p class="headline"></p>

                                <div style="display:inline-flex;gap:1em;position:absolute;right:2em;top:2em;">
                                  <div><button @click="print()" class="btn bt-outline" style="margin: 0;"><span>Imprimer</span></button></div>
                                  <div><button @click="printBlank()" class="btn bt-outline" style="margin: 0;"><span>Imprimer le bon vierge</span></button></div>
                                </div>

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <group-line-2>
                                  <form-text label="Code" v-model="resource.token" :required="true" class="form-slug"></form-text>
                                  <div style="align-self: self-end;margin-bottom: 1.875rem;" v-if="resource.id == null"><button class="btn" @click="generateCode()"><span>Générer un nouveau code</span></button></div>
                                </group-line-2>

                                <form-text label="Valeur du bon cadeau" v-model="resource.value" :suffix="$store.state.scope.currency_id" :required="true"></form-text>

                                <form-select-new label="Template"
                                                 multiple="false"
                                                 :required="true"
                                                 v-model="resource.template"
                                                 :default="resource.pdf_template_id"
                                                 :options="templates"></form-select-new>

                                <hr>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-text :lang="client.id" :translate-key="'name'" :translations="resource.translations" :label="'Nom'" v-model="resource.translations[client.id].name" :required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-text :lang="client.id" :translate-key="'description'" :translations="resource.translations" :label="'Description'" v-model="resource.translations[client.id].description"></form-text>
                                  </div>
                                </div>


                              </fieldset>
                            </tab>
                            <tab name="Transactions">
                              <fieldset>
                                <h3>Transactions</h3>
                                <p class="headline"></p>

                                <div v-for="item in transactions" style="display: flex;gap: 2em;">
                                  <strong>{{ item.order.reference }}</strong>
                                  <span><datetime v-model="item.order.created_at" :human="false"></datetime></span>
                                  <span class="price"><i>{{ item.order.currency }}</i> {{ item.amount }}</span>
                                </div>

                              </fieldset>
                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import GiftcardService from './GiftcardService.js';
    import PersonService from '../../person/PersonService.js';
    import Edit from '../../../layouts/Edit.vue';
    import ScopeService from "../../scope/ScopeService";
    import VoucherService from "../voucher/VoucherService";
    import PdfTemplateService from '../../config/pdf-template/PdfTemplateService.js';

    export default {
        extends: Edit,
        data () {
            return {
                token: null,
                service: null,
                conditions: [],
                transactions: [],
                templates: []
            }
        },
        mounted: function(){

            this.service = PersonService;

          PdfTemplateService.all().then(response => {
            this.templates = response.data
            this.isLoading = false
          });

        },
        methods:{
            slugify: function(string){
              return string.toUpperCase()
                    .trim()
                    .replace(/[^\w\s-]/g, '')
                    .replace(/[\s_-]+/g, '-')
                    .replace(/^-+|-+$/g, '')
                    .replace(/ /g, '-');
            },
            resourceLoaded: function(){
                this.setTranslations(['name','description']);
                this.conditions = this.resource.conditions || [];
                this.resource.value = this.resource.value || 0;

                /* CONVERT DATES TO LOCAL TIMZONE */
                this.resource.start_at = this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone).format() : null;
                this.resource.end_at = this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone).format() : null;
                /*****/



              GiftcardService.transactions(this.resource.id).then(response => {
                  this.transactions = response.data;
                  this.isLoading = false
                });

                if( this.resource.token == null ){
                  this.generateCode();
                }

                this.initialize()
            },
            generateCode:function(){
              GiftcardService.generate().then(response => {
                this.resource.token = response.data;
                this.$forceUpdate()
              });
            },
            getResource: function(){
                return GiftcardService
            },
            beforeUpdate: function(Resource){

              Resource.pdf_template_id = Resource.template.id || null;

                return true;
            },
            print: function () {
              window.open(this.resource.download_link, 'Download Giftcard');
            },
            printBlank: function () {
              window.open(this.resource.download_link + "?blank", 'Download Giftcard');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/giftcard/Edit.vue